
export default function areSameObject(a, b) {

    return JSON.stringify(a) === JSON.stringify(b);
}